import { ITransactionStatus } from "~/lib/types/payment.type";

interface IHelpBadgeProps {
  status?: string;

  className?: string;
}

const Badge = ({ status, className = "" }: IHelpBadgeProps) => {
  return (
    <>
      {status && (
        <div
          className={`${className} ${badgeStatus(
            status
          )} text-white rounded px-1 py-0.5`}
        >
          <p className="text-xs leading-4 font-bold uppercase tracking-[0.08em]">
            {status}
          </p>
        </div>
      )}
    </>
  );
};

const badgeStatus = (color: string) => {
  switch (color) {
    case ITransactionStatus.SUCCESS:
      return "";
    case ITransactionStatus.FAILED:
    case ITransactionStatus.ERROR:
    case ITransactionStatus.CANCELLED:
      return "bg-error";
    case ITransactionStatus.PENDING:
    case ITransactionStatus.INCOMING:
      return "bg-lemon";
    case ITransactionStatus.REVERSED:
      return "bg-blue";
    case ITransactionStatus.EXPIRED:
      return "bg-grey";
    default:
      return "";
  }
};

export default Badge;
